import * as React from 'react';
import { Input } from '@/components/ui/input';
import { cleanRut, formatRut } from '@condo/domain-chile';

export interface RutInputProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'onChange' | 'value'> {
  value?: string;
  onChange?: (rut: string) => void;
}

/** Free-typing RUT field with automatic "12.345.678-5" format on blur. */
export const RutInput = React.forwardRef<HTMLInputElement, RutInputProps>(
  ({ value, onChange, onBlur, ...props }, ref) => {
    const [internal, setInternal] = React.useState<string>(value ?? '');

    React.useEffect(() => {
      setInternal(value ?? '');
    }, [value]);

    return (
      <Input
        ref={ref}
        inputMode="text"
        autoComplete="off"
        spellCheck={false}
        placeholder="12.345.678-5"
        value={internal}
        onChange={(e) => {
          const raw = e.target.value;
          setInternal(raw);
          onChange?.(raw);
        }}
        onBlur={(e) => {
          const cleaned = cleanRut(internal);
          if (cleaned.length >= 2) {
            try {
              const pretty = formatRut(cleaned);
              setInternal(pretty);
              onChange?.(pretty);
            } catch {
              /* leave as-is, validator will flag */
            }
          }
          onBlur?.(e);
        }}
        {...props}
      />
    );
  },
);
RutInput.displayName = 'RutInput';
